// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Qd-z","play":"Rd-z"};